<p-overlayPanel #op
    id="opInventarioOuLote"
    name="opInventarioOuLote"
    [dismissable]="true"
    (onShow)="onShow()"
    (onHide)="onHide()">

    <app-my-select
      #mySelect
      name="mySelect"
      [optionLabel]="optionLabel"
      [options]="options" >
    </app-my-select>
</p-overlayPanel>
